import React from 'react';
import Menu from './Menu';
import { MenuItem } from './MenuItem';

interface FileMenuProps {
  items: MenuItem[];
}

const FileMenu: React.FC<FileMenuProps> = ({ items }) => {
  return (
    <Menu items={items} />
  );
};

export default FileMenu; 